import React from 'react'
import styled from '@emotion/styled'

import {Text, TextAlign, TitleVariant} from '@vio/atlas/Text'
import {linariaMq} from '@vio/atlas/utils/breakpoints'
import FormattedMessageWrapper from '@vio/core/src/localization/components/FormattedMessage'

type AppExclusiveDealLabelProps = {
  variant?: TitleVariant
  alignText?: TextAlign
}

const Label = styled(Text)`
  ${linariaMq.mobileLg} {
    white-space: nowrap;
  }
`

export const AppExclusiveDealLabel = ({
  variant = 'titleXS',
  alignText = 'start'
}: AppExclusiveDealLabelProps) => {
  return (
    <Label
      variant={variant}
      colorPath="content.brand.primary"
      align={alignText}
    >
      <FormattedMessageWrapper
        id="offer.vioAppExclusive"
        defaultMessage="Vio app exclusive"
      />
    </Label>
  )
}
